var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBifrost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 0C8.58121 0 0 8.58121 0 19.1667V80.8333C0 91.4188 8.58121 100 19.1667 100H80.8333C91.4188 100 100 91.4188 100 80.8333V19.1667C100 8.58121 91.4188 0 80.8333 0H19.1667ZM63.6888 29.4666H77.4814L49.8962 70.8443H22.311L63.6888 29.4666Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBifrost);
export default __webpack_public_path__ + "static/media/bifrost.4ce936667dd3dd29a7d4a5ab7819d8ce.svg";
export { ForwardRef as ReactComponent };